export const TOOLS_CODE_EDITING = `
# Code Editing Tools

- Read the surrounding file before editing so imports, exports, formatting, and local conventions stay coherent.
- Use structured parsers or existing helpers when they are available for the file type.
- After editing, re-open the changed file and verify the connected import/export and configuration paths.
`;
